import {lazy} from 'react';

const loadModule = () => import('./routes/ModuleRoutes');
export const MainModule = lazy(loadModule);

export default MainModule;
